import { EstadoMovimientoBeca } from '../model/enumerations/estado-movimiento-beca.model';

export default function resolveEstadoMovimientoBecaVariant(estado: EstadoMovimientoBeca) {
  switch (estado) {
    case EstadoMovimientoBeca.REVISADO:
      return 'warning';
    case EstadoMovimientoBeca.RECHAZADO:
      return 'danger';
    case EstadoMovimientoBeca.AUTORIZADO:
      return 'info';
    case EstadoMovimientoBeca.SOLICITADO:
      return 'primary';
    case EstadoMovimientoBeca.APLICADO:
      return 'success';
    default:
      return 'primary';
  }
}
